import React, { useEffect, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import { baseUrl } from "../../../constants";

const Engine = ({ vehicleData }) => {
  // console.log(vehicleData)
  const [batteryPercent, setBatteryPercent] = useState(10);
  const [batteryColor, setBatteryColor] = useState("rgba(170, 203, 108, 0.33)");
  const [batteryStrokeColor, setBatteryStrokeColor] = useState("#AACB6C");

  const [rpm, setRPM] = useState(2600);
  const [rpmColor, setRPMColor] = useState("rgba(170, 203, 108, 0.33)");
  const [rpmStrokeColor, setRPMStrokeColor] = useState("#AACB6C");

  const [Temperature, setTemperature] = useState(127);
  const [tempColor, setTempColor] = useState("rgba(170, 203, 108, 0.33)");
  const [tempStrokeColor, setTempStrokeColor] = useState("#AACB6C");

  const [speed, setSpeed] = useState(60);
  const [speedColor, setSpeedColor] = useState("rgba(170, 203, 108, 0.33)");
  const [speedStrokeColor, setSpeedStrokeColor] = useState("#AACB6C");

  const [batterythreshold, setBatteryThreshold] = useState(12.5);
  const [rpmthreshold, setRPMThreshold] = useState(5000);
  const [speedthreshold, setSpeedThreshold] = useState(100);
  const [temperaturethreshold, setTemperatureThreshold] = useState(100);
  // const [selectedModel, setSelectedModel] = useState(localStorage.getItem('selectedModel'));

  const [vin, setVinNumber] = useState("");

  const getJwtToken = () => {
    let token = localStorage.getItem("token") || undefined;
    return token === undefined ? "" : `${JSON.parse(token)}`;
  };

  useEffect(() => {
    // console.log(rpmthreshold + " " + rpm)
    if (batteryPercent < batterythreshold) {
      setBatteryColor("rgba(255, 100, 101, 0.33)");
      setBatteryStrokeColor("#FF6465");
    } else {
      setBatteryColor("rgba(170, 203, 108, 0.33)");
      setBatteryStrokeColor("#AACB6C");
    }

    if (Temperature > temperaturethreshold) {
      setTempColor("rgba(255, 100, 101, 0.33)");
      setTempStrokeColor("#FF6465");
    } else {
      setTempColor("rgba(170, 203, 108, 0.33)");
      setTempStrokeColor("#AACB6C");
    }

    if (speed > speedthreshold) {
      // console.log(speed)
      setSpeedColor("rgba(255, 100, 101, 0.33)");
      setSpeedStrokeColor("#FF6465");
    } else {
      setSpeedColor("rgba(170, 203, 108, 0.33)");
      setSpeedStrokeColor("#AACB6C");
    }

    if (rpm > rpmthreshold) {
      // console.log(speed)
      setRPMColor("rgba(255, 100, 101, 0.33)");
      setRPMStrokeColor("#FF6465");
    } else {
      setRPMColor("rgba(170, 203, 108, 0.33)");
      setRPMStrokeColor("#AACB6C");
    }
  });

  useEffect(() => {
    // console.log(vehicleData)
    if (vehicleData.speed !== undefined) {
      const sp = vehicleData.speed;
      const rp = vehicleData.rpm;
      const temp = vehicleData.temperature;
      const bat = vehicleData.battery;
      if (sp < 500) setSpeed(sp);
      if (rp < 15000) setRPM(Math.floor(rp));
      if (bat < 100) setBatteryPercent(Math.floor(bat));
      if (temp < 200) setTemperature(temp);
    }
    console.log("Vehicle",vehicleData)
    if (vehicleData.graph === 0) {
      setVinNumber(vehicleData.vin);
    }
  });

  useEffect(() => {
    const body = { vin: vin };
    const url3 = baseUrl + "/basicDetails/threshold/data/";

    const fetchThershold = async () => {
      await axios
        .post(url3, body, {
          headers: { Authorization: `Bearer ${getJwtToken()}` },
        })
        .then((res) => {
          const temp = res.data.result;
          // console.log(temp)
          setTemperatureThreshold(temp.temperature);
          setBatteryThreshold(temp.battery);
          setRPMThreshold(temp.rpm);
          setSpeedThreshold(temp.speed);
        })
        .catch((err) => {
          console.log(err)
        });
    };
    if(vin != ""){
      fetchThershold();
    }
  }, [vin]);

  return (
    <div className="engine_details">
      <div className="ed_head">Engine Details</div>
      <div className="engine_detail_main">
        <div className="energy_details">
          <div className="energy_icon">
            <svg
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="13.0286"
                cy="13.0286"
                r="13.0286"
                fill="black"
                fill-opacity="0.06"
              />
              <path
                d="M15.5503 5H9.67114L9 13.3712H11.7047L10.1107 20L17 10.5808H13.8926L15.5503 5Z"
                fill="black"
              />
            </svg>
          </div>

          <div className="energy_title">RPM</div>
          {/* <div className="energy_bar_display">
                        <div></div>
                        <div className="energy_perc">67%</div>
                    </div> */}
          <div className="energy_bar_display">
            <CircularProgressbar
              value={rpm}
              minValue={0}
              maxValue={6000}
              text={`${rpm}`}
              background={true}
              styles={{
                // Customize the root svg element
                root: {},
                // Customize the path, i.e. the "completed progress"
                path: {
                  // Path color
                  stroke: `${rpmStrokeColor}`,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  // Customize transition animation
                  transition: "stroke-dashoffset 0.5s ease 0s",
                  // Rotate the path
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the circle behind the path, i.e. the "total progress"
                trail: {
                  // Trail color
                  stroke: `${rpmColor}`,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  opacity: 0.1,
                  // Rotate the trail
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the text
                text: {
                  fill: "black",
                  fontSize: "1vmax",
                  fontWeight: "700",
                },
                // Customize background - only used when the `background` prop is true
                background: {
                  fill: `${rpmColor}`,
                },
              }}
            />
          </div>
        </div>

        <div className="range_details">
          <div className="range_icon">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12.7785"
                cy="12.7785"
                r="12.7785"
                fill="black"
                fill-opacity="0.06"
              />
              <path
                d="M9.5793 6.31364C9.6926 6.17114 9.85059 6.07096 10.0278 6.02925C10.1724 5.99025 10.326 5.99025 10.4698 6.02925C10.6479 6.07045 10.8068 6.17068 10.9207 6.31364L13.2559 8.55543C13.58 8.86501 13.58 9.36797 13.2559 9.67836L13.2299 9.70274C13.0715 9.85233 12.8619 9.93567 12.644 9.93567C12.4262 9.93567 12.2166 9.85233 12.0582 9.70274L11.0962 8.78051V14.9379C11.0962 15.3864 10.7339 15.7505 10.2862 15.7505H10.213C9.99791 15.75 9.79175 15.6642 9.63986 15.5118C9.48797 15.3595 9.40277 15.1531 9.40298 14.9379V8.77888L8.44017 9.70355C8.2818 9.85314 8.07221 9.93649 7.85436 9.93649C7.63651 9.93649 7.42692 9.85314 7.26855 9.70355L7.24255 9.67836C7.16597 9.60626 7.10494 9.51926 7.06323 9.42271C7.02152 9.32615 7 9.22208 7 9.1169C7 9.01171 7.02152 8.90764 7.06323 8.81109C7.10494 8.71453 7.16597 8.62753 7.24255 8.55543L9.5793 6.31445V6.31364ZM17.4199 18.687C17.3066 18.8295 17.1486 18.9297 16.9714 18.9714C16.8266 19.0095 16.6743 19.0095 16.5294 18.9714C16.3513 18.9302 16.1924 18.83 16.0785 18.687L13.7434 16.4452C13.6668 16.3731 13.6057 16.2861 13.564 16.1895C13.5223 16.093 13.5008 15.9889 13.5008 15.8837C13.5008 15.7785 13.5223 15.6745 13.564 15.5779C13.6057 15.4813 13.6668 15.3943 13.7434 15.3222L13.7694 15.2979C13.9277 15.1483 14.1373 15.0649 14.3552 15.0649C14.573 15.0649 14.7826 15.1483 14.941 15.2979L15.9038 16.2201V10.0627C15.9038 9.61417 16.2662 9.25015 16.7138 9.25015H16.787C17.2338 9.25015 17.597 9.61417 17.597 10.0627V16.2217L18.5598 15.2979C18.7182 15.1483 18.9278 15.0649 19.1457 15.0649C19.3635 15.0649 19.5731 15.1483 19.7315 15.2979L19.7575 15.3231C20.0808 15.6335 20.0808 16.1356 19.7575 16.446L17.4207 18.687H17.4199Z"
                fill="black"
              />
            </svg>
          </div>

          <div className="range_title">Engine Coolant Temperature</div>
          <div className="range_bar_display">
            <CircularProgressbar
              value={Temperature}
              text={`${Temperature}\u00B0C`}
              maxValue={200}
              minValue={0}
              background={true}
              styles={{
                // Customize the root svg element
                root: {},
                // Customize the path, i.e. the "completed progress"
                path: {
                  // Path color
                  stroke: `${tempStrokeColor}`,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  // Customize transition animation
                  transition: "stroke-dashoffset 0.5s ease 0s",
                  // Rotate the path
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the circle behind the path, i.e. the "total progress"
                trail: {
                  // Trail color
                  stroke: `${tempColor}`,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  opacity: 0.1,
                  // Rotate the trail
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the text
                text: {
                  fill: "black",
                  fontSize: "1vmax",
                  fontWeight: "700",
                },
                // Customize background - only used when the `background` prop is true
                background: {
                  fill: `${tempColor}`,
                },
              }}
            />
          </div>
        </div>

        <div className="battery_details">
          <div className="battery_icon">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="13" cy="13" r="13" fill="black" fill-opacity="0.06" />
              <path
                d="M10 9.5L10 18.6C10 19.37 10.63 20 11.4 20L15.6 20C16.37 20 17 19.37 17 18.6V13.91C17 14.33 16.72 14.61 16.3 14.61C16.16 14.61 16.09 14.61 15.95 14.54L14.2 13.56L14.2 15.8C14.2 15.87 14.2 15.94 14.13 16.01V16.08V16.15L14.06 16.22C14.06 16.29 13.99 16.29 13.99 16.36C13.92 16.43 13.85 16.43 13.78 16.5C13.71 16.5 13.71 16.5 13.64 16.5H13.57C13.57 16.5 13.57 16.5 13.5 16.5C13.43 16.5 13.29 16.43 13.22 16.43C13.22 16.43 13.22 16.43 13.15 16.43L10.35 14.82C10 14.61 9.93 14.19 10.07 13.84C10.28 13.49 10.7 13.42 11.05 13.56L12.8 14.61L12.8 12.3C12.8 12.3 12.8 12.3 12.8 12.23C12.8 12.16 12.87 12.02 12.87 11.95C12.87 11.95 12.87 11.95 12.87 11.88L12.94 11.81C12.94 11.74 13.01 11.74 13.01 11.67C13.08 11.6 13.15 11.6 13.22 11.53C13.29 11.53 13.29 11.53 13.36 11.53H13.43C13.43 11.53 13.43 11.53 13.5 11.53C13.57 11.53 13.71 11.6 13.78 11.6C13.78 11.6 13.78 11.6 13.85 11.6L16.65 13.21C16.86 13.42 17 13.7 17 13.91L17 9.5C17 8.73 16.37 8.1 15.6 8.1L11.4 8.1C10.63 8.1 10 8.73 10 9.5ZM12.1 6.7C12.1 7.12 12.38 7.4 12.8 7.4H14.2C14.62 7.4 14.9 7.12 14.9 6.7C14.9 6.28 14.62 6 14.2 6H12.8C12.38 6 12.1 6.28 12.1 6.7Z"
                fill="black"
              />
            </svg>
          </div>

          <div className="battery_title">Battery</div>
          <div className="battery_bar_display">
            <CircularProgressbar
              value={batteryPercent}
              text={`${batteryPercent}%`}
              maxValue={100}
              minValue={0}
              background={true}
              styles={{
                // Customize the root svg element
                root: {},
                // Customize the path, i.e. the "completed progress"
                path: {
                  // Path color
                  stroke: `${batteryStrokeColor}`,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  // Customize transition animation
                  transition: "stroke-dashoffset 0.5s ease 0s",
                  // Rotate the path
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the circle behind the path, i.e. the "total progress"
                trail: {
                  // Trail color
                  stroke: `${batteryColor}`,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  opacity: 0.1,
                  // Rotate the trail
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the text
                text: {
                  fill: "black",
                  fontSize: "1vmax",
                  fontWeight: "700",
                },
                // Customize background - only used when the `background` prop is true
                background: {
                  fill: `${batteryColor}`,
                },
              }}
            />
          </div>
        </div>

        <div className="tire_details">
          <div className="tire_icon">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="13" cy="13" r="13" fill="black" fill-opacity="0.06" />
              <path
                d="M18.4404 12.6794C18.3672 12.6547 18.3068 12.602 18.2725 12.5329C18.2382 12.4637 18.2328 12.3837 18.2574 12.3106C18.2821 12.2374 18.3348 12.177 18.4039 12.1427C18.4731 12.1084 18.5531 12.103 18.6263 12.1276L19.0996 12.2844C19.0107 10.7222 18.3718 9.24186 17.2962 8.10546C16.8838 8.32326 16.878 8.32326 16.7909 8.32326C16.7258 8.32288 16.6628 8.30068 16.6119 8.26022C16.561 8.21976 16.5251 8.16339 16.5101 8.10012C16.495 8.03686 16.5016 7.97038 16.5288 7.91132C16.5561 7.85226 16.6023 7.80404 16.6602 7.77439L16.8548 7.67565C15.6921 6.63895 14.2009 6.04559 12.6438 6C12.4522 6.58082 12.4348 6.87122 12.1443 6.87122C12.0982 6.87134 12.0526 6.86045 12.0115 6.83945C11.9704 6.81844 11.9349 6.78794 11.9079 6.75046C11.8809 6.71298 11.8633 6.66961 11.8564 6.62394C11.8495 6.57828 11.8537 6.53163 11.8685 6.48789L12.0253 6.01452C10.4681 6.10682 8.99348 6.74544 7.86083 7.81795L8.04669 8.19258C8.07488 8.26027 8.07642 8.33612 8.05099 8.4049C8.02557 8.47368 7.97507 8.5303 7.90964 8.56338C7.8442 8.59647 7.76867 8.60358 7.6982 8.58328C7.62774 8.56298 7.56757 8.51678 7.52976 8.45395L7.43102 8.25937C6.39432 9.42207 5.80096 10.9132 5.75537 12.4703L6.42331 12.6939C6.4984 12.7178 6.56094 12.7705 6.59716 12.8405C6.63337 12.9105 6.64031 12.992 6.61643 13.0671C6.59255 13.1422 6.53982 13.2047 6.46984 13.2409C6.39986 13.2771 6.31835 13.2841 6.24326 13.2602L5.76989 13.1034C5.86574 14.6662 6.51183 16.1446 7.59365 17.2765L8.27611 17.05C8.34928 17.0254 8.42925 17.0308 8.49841 17.0651C8.56758 17.0994 8.62028 17.1598 8.64493 17.233C8.66958 17.3061 8.66415 17.3861 8.62984 17.4553C8.59553 17.5244 8.53514 17.5772 8.46197 17.6018L8.07863 17.7325C9.23192 18.7368 10.6971 19.3114 12.2257 19.3588L12.4493 18.6908C12.4739 18.6177 12.5266 18.5573 12.5958 18.523C12.665 18.4887 12.7449 18.4832 12.8181 18.5079C12.8913 18.5325 12.9516 18.5852 12.986 18.6544C13.0203 18.7236 13.0257 18.8035 13.001 18.8767L12.8442 19.3588C14.4121 19.2663 15.8962 18.62 17.0319 17.535L16.8054 16.8525C16.7932 16.8163 16.7882 16.778 16.7908 16.7399C16.7934 16.7018 16.8035 16.6645 16.8205 16.6302C16.8375 16.596 16.861 16.5654 16.8898 16.5403C16.9186 16.5152 16.9521 16.4959 16.9883 16.4837C17.0246 16.4715 17.0629 16.4666 17.101 16.4692C17.1391 16.4718 17.1764 16.4818 17.2107 16.4988C17.2449 16.5158 17.2755 16.5394 17.3006 16.5682C17.3257 16.597 17.345 16.6305 17.3572 16.6667L17.4879 17.0355C18.4922 15.8822 19.0668 14.4171 19.1141 12.8885L18.4404 12.6794ZM12.4348 17.9067C11.4009 17.9067 10.3902 17.6001 9.5306 17.0258C8.67097 16.4514 8.00096 15.635 7.60532 14.6798C7.20967 13.7246 7.10615 12.6736 7.30785 11.6596C7.50955 10.6456 8.00741 9.71415 8.73846 8.98309C9.46952 8.25204 10.4009 7.75418 11.4149 7.55248C12.429 7.35078 13.48 7.4543 14.4352 7.84995C15.3903 8.24559 16.2067 8.91559 16.7811 9.77523C17.3555 10.6349 17.6621 11.6455 17.6621 12.6794C17.6621 14.0658 17.1114 15.3954 16.131 16.3757C15.1507 17.356 13.8211 17.9067 12.4348 17.9067V17.9067Z"
                fill="black"
              />
              <path
                d="M11.2239 9.4102C11.2065 9.32018 11.2385 9.4828 11.0119 8.24857C10.3773 8.45156 9.79456 8.7905 9.30434 9.24177L10.2046 9.99683C10.5079 9.74386 10.8528 9.54538 11.2239 9.4102V9.4102ZM15.5684 9.25048C15.0762 8.80049 14.4928 8.46175 13.8579 8.25728C13.643 9.41892 13.6576 9.34051 13.6459 9.41892C14.0179 9.55149 14.3639 9.74805 14.6682 9.99973C14.7379 9.95036 14.5665 10.0927 15.5684 9.25048ZM15.8734 12.0994C15.9405 12.4964 15.9405 12.9018 15.8734 13.2988C15.9808 13.3452 15.8066 13.2784 16.9711 13.714C17.1234 13.0535 17.1294 12.3676 16.9885 11.7044C15.8472 12.1139 15.9402 12.0791 15.8734 12.0994ZM14.6217 15.3926C14.3301 15.6305 14.0015 15.8189 13.6488 15.9502C13.6634 16.0489 13.6314 15.866 13.8579 17.1118C14.4673 16.9117 15.0296 16.5896 15.5104 16.1651C14.6101 15.3781 14.6827 15.4391 14.6217 15.3926ZM9.35951 16.1331C9.8577 16.5462 10.4347 16.8535 11.0555 17.0363C11.2762 15.9095 11.2617 15.9967 11.2733 15.9241C10.9131 15.8015 10.5748 15.6221 10.2714 15.3926C10.193 15.4507 10.3179 15.3519 9.35951 16.1331V16.1331ZM9.00522 13.3104C8.93711 12.9135 8.93711 12.5079 9.00522 12.111C8.921 12.0761 9.14461 12.1575 7.89586 11.7131C7.75735 12.3766 7.76428 13.0622 7.91619 13.7228C9.03426 13.3017 8.95004 13.3394 9.00522 13.3104ZM10.495 12.0791C10.5809 11.7941 10.7298 11.5321 10.9306 11.3124C9.55699 10.235 10.0158 10.6096 8.89776 9.66867C8.52276 10.105 8.23401 10.6086 8.04687 11.1527C9.4234 11.6434 8.87163 11.4343 10.495 12.0791ZM10.9451 14.0625C10.7414 13.8452 10.5887 13.5853 10.4979 13.3017C8.89196 13.987 9.44083 13.7692 8.07881 14.2803C8.27559 14.8208 8.571 15.3201 8.95004 15.7527C10.0507 14.7915 9.60055 15.1748 10.9451 14.0625V14.0625ZM12.856 14.6695C12.5785 14.7291 12.2914 14.7291 12.0138 14.6695C11.7409 16.3945 11.8425 15.8108 11.5782 17.2512C12.1446 17.3558 12.7253 17.3558 13.2916 17.2512C13.0157 15.8079 13.129 16.3916 12.856 14.6695V14.6695ZM14.372 13.3017C14.2808 13.586 14.1281 13.8468 13.9247 14.0654C15.2693 15.1748 14.8192 14.7915 15.9227 15.7527C16.3018 15.3201 16.5972 14.8208 16.794 14.2803C15.429 13.7692 15.9779 13.987 14.372 13.3017V13.3017ZM13.9363 11.3153C14.1391 11.5329 14.2892 11.7942 14.3749 12.0791C16.0011 11.4343 15.4436 11.6434 16.823 11.1527C16.6359 10.6086 16.3471 10.105 15.9721 9.66867C14.854 10.6096 15.3129 10.235 13.9363 11.3153ZM12.0138 10.6909C12.2913 10.6299 12.5786 10.6299 12.856 10.6909C13.129 8.96588 13.0274 9.5496 13.2916 8.10918C12.7253 8.00462 12.1446 8.00462 11.5782 8.10918C11.8541 9.5525 11.7409 8.96878 12.0138 10.6909V10.6909ZM13.8347 12.294C13.7589 12.0195 13.604 11.7734 13.3894 11.5863C13.1748 11.3991 12.9099 11.2792 12.6277 11.2414C12.3455 11.2037 12.0584 11.2497 11.8021 11.3738C11.5459 11.4979 11.3318 11.6947 11.1864 11.9395C11.0411 12.1844 10.971 12.4665 10.9848 12.7509C10.9985 13.0353 11.0956 13.3094 11.264 13.5391C11.4323 13.7687 11.6644 13.9438 11.9315 14.0426C12.1986 14.1413 12.4888 14.1594 12.766 14.0945C12.9564 14.0499 13.1358 13.9674 13.2935 13.8518C13.4512 13.7362 13.584 13.5899 13.6838 13.4218C13.7836 13.2536 13.8484 13.0671 13.8743 12.8733C13.9002 12.6795 13.8868 12.4824 13.8347 12.294V12.294ZM12.4349 13.5514C12.2626 13.5514 12.0942 13.5003 11.9509 13.4046C11.8076 13.3089 11.696 13.1728 11.63 13.0136C11.5641 12.8544 11.5468 12.6792 11.5805 12.5102C11.6141 12.3412 11.697 12.186 11.8189 12.0641C11.9407 11.9423 12.096 11.8593 12.265 11.8257C12.434 11.7921 12.6091 11.8093 12.7683 11.8753C12.9275 11.9412 13.0636 12.0529 13.1593 12.1962C13.2551 12.3394 13.3062 12.5079 13.3062 12.6802C13.3062 12.9113 13.2144 13.1329 13.051 13.2962C12.8876 13.4596 12.666 13.5514 12.4349 13.5514Z"
                fill="black"
              />
            </svg>
          </div>

          <div className="tire_title"> Speed</div>
          <div className="tire_bar_display">
            <CircularProgressbar
              maxValue={300}
              minValue={0}
              value={speed}
              text={`${speed}Km/h`}
              background={true}
              styles={{
                // Customize the root svg element
                root: {},
                // Customize the path, i.e. the "completed progress"
                path: {
                  // Path color
                  stroke: `${speedStrokeColor}`,

                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  // Customize transition animation
                  transition: "stroke-dashoffset 0.5s ease 0s",
                  // Rotate the path
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the circle behind the path, i.e. the "total progress"
                trail: {
                  // Trail color
                  stroke: `${speedColor}`,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  opacity: 0.1,
                  // Rotate the trail
                  transform: "rotate(0.25turn)",
                  transformOrigin: "center center",
                },
                // Customize the text
                text: {
                  fill: "black",
                  fontSize: "1vmax",
                  fontWeight: "700",
                },
                // Customize background - only used when the `background` prop is true
                background: {
                  fill: `${speedColor}`,
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Engine;
